module.exports = __webpack_public_path__ + "static/media/conexao-venus.7e42d11a.png";